import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderHarkiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-harkiv/create-distribution-order-harkiv",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderHarkiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-harkiv/create-distribution-to-order-harkiv",
      params,
      callBackFn
    );
  },
  async getHarkivAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-harkiv/get-harkiv-account-distribution-debt",
      params,
      callBackFn
    );
  },
  async createDistributionOrderHarkivRegion(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-harkiv/create-distribution-order-harkiv-region",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderHarkivRegion(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-harkiv/create-distribution-to-order-harkiv-region",
      params,
      callBackFn
    );
  },
  async getHarkivRegionAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-harkiv/get-harkiv-region-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
